import React from 'react';
import cc from 'classcat';
import styles from './list.module.sass';
import { SkeletonList } from '../../Skeleton/SkeletonTable';
import { useAuthStore } from '../../../providers/RootStoreProvider';
import { Icon } from '../../Icon';
import { IconSVG } from '../../SpriteSVG';

const ListElement = ({ headers, items, isMobile }) => {
  const authStore = useAuthStore();

  return (
    <div className={styles.item}>
      <ul>
        {items.map((i, idx) => (
          <li key={`${i}_${idx}`}>
            {headers[idx].title !== 'id' ? (
              <>
                <p>
                  {headers[idx].title}{' '}
                  {headers[idx].title === 'Отправление' && '(По Москве)'}
                </p>
                <p>{i || '—'}</p>
              </>
            ) : (
              authStore.isManager && (
                <a
                  href={`/adm_n/index.html#!/cruises/${i[4]}`}
                  className={styles.button}
                  rel="noreferrer"
                >
                  <div>
                    <Icon
                      icon={
                        <IconSVG name={'common/edit'} width={16} height={16} />
                      }
                    />
                  </div>
                </a>
              )
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const List = ({ className, items, headers, loading, isMobile }) => (
  <div className={cc({ [className]: !!className })}>
    {loading && (
      <div className={styles.skeletons}>
        {new Array(4).fill(null).map((_, idx) => (
          <SkeletonList key={idx} />
        ))}
      </div>
    )}
    {!loading &&
      items &&
      items.length > 0 &&
      items.map((i, idx) => (
        <ListElement
          key={idx}
          headers={headers}
          items={i}
          isMobile={isMobile}
        />
      ))}
  </div>
);
